import { SearchIcon } from "lucide-react";
import { Input } from "../../ui/input/input";

interface SearchBoxProps {
	onSearch: (value: string) => void;
}

const SearchBox = ({ onSearch }: SearchBoxProps) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onSearch(e.target.value);
	};

	return (
		<div className="relative">
			<Input
				placeholder="Search"
				onChange={handleChange}
				className="py-[10px] pl-12 border-primary-50 placeholder:font-medium placeholder:text-sm placeholder:text-textLight placeholder:opacity-40 rounded-2xl text-textDark hover:border-gray-300 h-[43px] shadow-none"
			/>
			<SearchIcon
				stroke-width={3}
				className="absolute w-4 h-4 font-bold -translate-y-1/2 text-textLight left-5 top-1/2"
			/>
		</div>
	);
};

export default SearchBox;
